import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Systems(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Systems</h2>
                <li>
                    <Link to={`${url}/hydraulic`}>Hydraulic Systems</Link>
                </li>
                <li>
                    <Link to={`${url}/pneumatic`}>Pneumatic Systems</Link>
                </li>
                <li>
                    <Link to={`${url}/cooling`}>Cooling Systems</Link>
                </li>
                <li>
                    <Link to={`${url}/combustion`}>Combustion Systems</Link>
                </li>  
                <li>
                    <Link to={`${url}/hvac`}>HVAC Systems</Link>
                </li>  
                <li>
                    <Link to={`${url}/chromatography`}>Chromatography</Link>
                </li>             
                   <li>
                    <Link to={`${url}/suspension`}>Suspension Systems</Link>
                </li>  
                  <li>
                    <Link to={`${url}/corexy`}>Core XY Motors</Link>
                </li>  
                  <li>
                    <Link to={`${url}/multiplexmotors`}>Multiplex Motors</Link>
                </li>  
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Systems; 